import React, { useEffect } from "react";
import { Container, Typography, Grid, Box, Divider } from "@mui/material";
import AccountSummaryCard from "./AccountSummaryCard";
import LoyaltyPointsCard from "./LoyaltyPointsCard";
import OrderHistorySummary from "./OrderHistorySummary";
import AccountDetailsForm from "./AccountDetailsForm";
import ChangePasswordButton from "./ChangePasswordButton";

const MyAccountPage = () => {
  useEffect(() => {
    document.title = "My Account";
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 10 }}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          My Account
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage your personal details and account preferences
        </Typography>
      </Box>

      <Grid container spacing={{ xs: 4, md: 6 }}>
        {/* Left Sidebar */}
        <Grid item xs={12} md={4} lg={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              boxShadow: 1,
              bgcolor: "#fff",
              p: 3,
              borderRadius: 3,
            }}>
            <AccountSummaryCard />
            <Divider />
            <LoyaltyPointsCard />
            <Divider />
            <OrderHistorySummary />
          </Box>
        </Grid>

        {/* Right Form Area */}
        <Grid item xs={12} md={8} lg={6}>
          <Box
            sx={{
              boxShadow: 1,
              bgcolor: "#fff",
              p: 3,
              borderRadius: 3,
            }}>
            <AccountDetailsForm />

            <Divider sx={{ my: 3 }} />

            <Typography variant="subtitle2" fontWeight="bold" mb={1}>
              Security
            </Typography>
            <ChangePasswordButton />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MyAccountPage;
